import { Button, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { formatMoney } from 'helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ADSelectedAppeals = ({
  items,
  transactionFee,
  subtotal,
  total,
  onEdit,
  onRemove,
  onQuantityChange
}) => {
  return (
    <Card className="mb-3">
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">Selected Appeals</Card.Title>
      </Card.Header>
      <Card.Body>
        {items.length === 0 && (
          <h5 className="text-center text-500">No appeals selected</h5>
        )}
        {items?.map(({ amount, quantity = 1, type, name, billingCondition, currencySymbol = '£' }, index) => (
          <Flex
            key={index}
            justifyContent={'between'}
            alignItems={'center'}
            className="border rounded-3 p-3 mb-3"
          >
            <div className="flex-1">
              <p className="mb-1 fw-medium">
                {billingCondition === 'one-off' ? 'One-Off' : 'Monthly'} | {type.name} | {name}
              </p>
              <Flex alignItems="center" className="gap-2 mb-0">
                <span className="fw-medium">Qty:</span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                  style={{ width: 28, height: 28 }}
                  onClick={() => onQuantityChange(index, quantity - 1)}
                  disabled={quantity <= 1}
                >
                  <FontAwesomeIcon icon="minus" style={{ fontSize: 10 }} />
                </Button>
                <span className="fw-semi-bold" style={{ minWidth: 20, textAlign: 'center' }}>
                  {quantity}
                </span>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="rounded-circle p-0 d-flex align-items-center justify-content-center"
                  style={{ width: 28, height: 28 }}
                  onClick={() => onQuantityChange(index, quantity + 1)}
                >
                  <FontAwesomeIcon icon="plus" style={{ fontSize: 10 }} />
                </Button>
                <span className="ms-2 fw-medium">
                  {currencySymbol}{amount} x {quantity} ={' '}
                  <span className="text-primary">{currencySymbol}{(amount * quantity).toFixed(2)}</span>
                </span>
              </Flex>
            </div>
            <Flex className="ms-2">
              <IconButton
                icon={'pen'}
                iconClassName="me-1"
                variant="link"
                className="p-0"
                onClick={() => onEdit(index)}
              >
                <span className="d-none d-md-inline-block">Edit</span>
              </IconButton>
              <IconButton
                icon={'trash'}
                iconClassName="text-danger"
                variant="link"
                className="p-0 ms-3"
                onClick={() => onRemove(index)}
              />
            </Flex>
          </Flex>
        ))}
        <hr />
        <Flex justifyContent={'between'}>
          <div>
            <p className="fw-medium mb-2 fs-1">Subtotal</p>
            <p className="fw-medium mb-2 fs-1">Transaction Fees</p>
            <p className="mb-0 text-1000 fw-semi-bold fs-1">Total amount</p>
          </div>
          <div>
            <p className="fw-medium mb-2 text-end fs-1">{formatMoney(subtotal)}</p>
            <p className="fw-medium mb-2 text-end fs-1">
              {formatMoney(transactionFee)}
            </p>
            <p className="mb-0 text-1000 fw-semi-bold text-end fs-1">
              {formatMoney(total)}
            </p>
          </div>
        </Flex>
      </Card.Body>
    </Card>
  );
};

ADSelectedAppeals.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      quantity: PropTypes.number,
      type: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
      billingCondition: PropTypes.string,
      name: PropTypes.string,
      currencySymbol: PropTypes.string
    })
  ),
  transactionFee: PropTypes.number,
  subtotal: PropTypes.number,
  total: PropTypes.number,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  onQuantityChange: PropTypes.func
};

ADSelectedAppeals.defaultProps = {
  items: [],
  transactionFee: 0,
  total: 0
};

export default ADSelectedAppeals;
